export default __webpack_public_path__ + "static/media/reception-custom.950936fe.svg";